export default __webpack_public_path__ + "static/media/data-visualization.1f99d9c8.png";